document.addEventListener('DOMContentLoaded', function () {
  // --- Inject mobile CSS for accordion behavior ---
  var css = `
    @media (max-width: 767px) {
      .iwt-accordion-toggle {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0;
        border: none;
        border-bottom: 1px solid #e5e5e5;
        background: transparent;
        font: inherit;
        text-align: left;
        cursor: pointer;
      }

      .iwt-accordion-title {
        font-weight: 400;
        font-size: 24px;
        color: black;
      }

      .iwt-accordion-icon {
        margin-left: 12px;
        font-size: 20px;
        line-height: 1;
        color: black;
      }

      .iwt-hide-heading .image-with-text__heading {
        display: none !important;
      }

      .image-with-text__media {
        min-height: 360px !important;
      }

      .image-with-text__grid {
        flex-direction: column-reverse;
      }
    }

    @media (min-width: 768px) {
      .image-with-text__content {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
        padding-left: 0px !important;
      }
      
      .image-with-text__media img {
        position: relative !important;
        display: block !important;
        max-height: 25%;
      }
    }
  `;
  var styleEl = document.createElement('style');
  styleEl.type = 'text/css';
  styleEl.appendChild(document.createTextNode(css));
  document.head.appendChild(styleEl);

  // Grab all Image with text sections
  var sections = document.querySelectorAll('.shopify-section .image-with-text');

  // =========================
  // DESKTOP: merge all h2 + text into first content container
  //         + build exact 4-image stack with last image as 4th
  //         + hide extra section-template image_with_text wrappers
  // =========================
  if (window.innerWidth > 767) {
    // --- merge headings + text into first content ---
    var contents = document.querySelectorAll(
      '.shopify-section .image-with-text .image-with-text__content'
    );

    if (contents.length > 1) {
      var firstContent = contents[0];

      for (var i = 1; i < contents.length; i++) {
        var block = contents[i];

        var heading = block.querySelector('.image-with-text__heading');
        var text = block.querySelector('.image-with-text__text');

        // Clone heading + text into the first content container
        if (heading) {
          var clonedHeading = heading.cloneNode(true);

          // scale heading font-size to 70% of original
          var cs = window.getComputedStyle(heading);
          var origSize = parseFloat(cs.fontSize);
          if (!isNaN(origSize)) {
            clonedHeading.style.fontSize = (origSize * 0.7) + 'px';
          }

          firstContent.appendChild(clonedHeading);
          heading.style.display = 'none';
        }

        if (text) {
          var clonedText = text.cloneNode(true);
          firstContent.appendChild(clonedText);
          text.style.display = 'none';
        }
      }
    }

    // --- build 4-image stack on the first image-with-text__media ---
    var mediaBlocks = document.querySelectorAll(
      '.shopify-section .image-with-text .image-with-text__media'
    );

    if (mediaBlocks.length > 0) {
      var firstMedia = mediaBlocks[0];

      // Collect all images from all media blocks in DOM order
      var allImgs = [];
      mediaBlocks.forEach(function (mediaBlock) {
        var imgs = mediaBlock.querySelectorAll('img');
        imgs.forEach(function (img) {
          allImgs.push(img);
        });
      });

      if (allImgs.length) {
        // Clear the first media container
        while (firstMedia.firstChild) {
          firstMedia.removeChild(firstMedia.firstChild);
        }

        var finalImgs = [];
        var lastImg = allImgs[allImgs.length - 1];

        if (allImgs.length >= 4) {
          // 1st, 2nd, 3rd, and then LAST as 4th
          finalImgs.push(allImgs[0]);
          finalImgs.push(allImgs[1]);
          finalImgs.push(allImgs[2]);
          // if last is already one of first three, it's ok to duplicate
          finalImgs.push(lastImg !== allImgs[2] ? lastImg : lastImg.cloneNode(true));
        } else if (allImgs.length === 3) {
          // Use 1,2,3 and clone last (3rd) as 4th
          finalImgs.push(allImgs[0]);
          finalImgs.push(allImgs[1]);
          finalImgs.push(allImgs[2]);
          finalImgs.push(allImgs[2].cloneNode(true));
        } else if (allImgs.length === 2) {
          // 1,2, then clone 2 twice
          finalImgs.push(allImgs[0]);
          finalImgs.push(allImgs[1]);
          finalImgs.push(allImgs[1].cloneNode(true));
          finalImgs.push(allImgs[1].cloneNode(true));
        } else if (allImgs.length === 1) {
          // single image repeated 4 times
          finalImgs.push(allImgs[0]);
          finalImgs.push(allImgs[0].cloneNode(true));
          finalImgs.push(allImgs[0].cloneNode(true));
          finalImgs.push(allImgs[0].cloneNode(true));
        }

        // Append final 4 images into the first media block
        finalImgs.forEach(function (img) {
          firstMedia.appendChild(img);
        });
      }
    }

    // --- hide all extra section-template image_with_text wrappers except the first ---
    var wrappers = document.querySelectorAll(
      '.shopify-section [class*="section-template"][class*="image_with_text"]'
    );

    if (wrappers.length > 1) {
      for (var k = 1; k < wrappers.length; k++) {
        wrappers[k].style.display = 'none';
      }
    }

    // Stop here on desktop (no accordion)
    return;
  }

  // =========================
  // MOBILE: accordion behavior (unchanged)
  // =========================

  // --- Only run accordion behavior on mobile ---
  var firstOpenDone = false;

  sections.forEach(function (imageWithText) {
    // Avoid double-init
    if (imageWithText.dataset.iwtAccordion === 'true') return;
    imageWithText.dataset.iwtAccordion = 'true';

    var grid = imageWithText.querySelector('.image-with-text__grid');
    var headingEl = imageWithText.querySelector('.image-with-text__heading');

    if (!grid || !headingEl) return;

    // Create the accordion toggle row
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'iwt-accordion-toggle';
    toggle.innerHTML =
      '<span class="iwt-accordion-title">' +
      headingEl.innerHTML +
      '</span><span class="iwt-accordion-icon">+</span>';

    // Insert toggle before the grid
    grid.parentNode.insertBefore(toggle, grid);

    // Hide original heading (text is now in the toggle)
    var contentWrapper = headingEl.closest('.image-with-text__content');
    if (contentWrapper) {
      contentWrapper.classList.add('iwt-hide-heading');
    }
    headingEl.remove();

    // Make the grid a collapsible panel
    grid.classList.add('iwt-accordion-panel');

    var icon = toggle.querySelector('.iwt-accordion-icon');

    // --- First one open by default ---
    if (!firstOpenDone) {
      firstOpenDone = true;
      toggle.classList.add('is-open');
      grid.style.display = ''; // open (let theme CSS decide: grid/block)
      if (icon) icon.textContent = '−';
    } else {
      // Others collapsed
      grid.style.display = 'none';
      if (icon) icon.textContent = '+';
    }

    // Toggle open / close
    toggle.addEventListener('click', function () {
      var isOpen = toggle.classList.toggle('is-open');
      var iconInner = toggle.querySelector('.iwt-accordion-icon');

      if (isOpen) {
        grid.style.display = '';
        if (iconInner) iconInner.textContent = '−';
      } else {
        grid.style.display = 'none';
        if (iconInner) iconInner.textContent = '+';
      }
    });
  });
});
